/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell, ColumnInterface } from 'react-table';

import { IconMediaFolder } from '../..';

import { defaultCellWidth } from '../constants';

interface Props<D extends object> {
    cell: Cell<D>;
    column: ColumnInterface<D>;
}

/**
 * Renders an icon that opens an external link. The link leads to a page where the user can review
 * the media (video or audio) where their audio file was detected.
 *
 * The cell value is expected to be the `match_reference` on an item in the `listBmatDetections`
 * query.
 */
export function MatchReferenceCell<D extends object>({
    cell,
    column,
}: Props<D>): Maybe<JSX.Element> {
    const width = (column?.width as number) ?? defaultCellWidth;

    if (cell.value === null) {
        return null;
    }

    return (
        <div
            className="respond-to-mouse"
            style={{
                width,
            }}
        >
            <a href={cell.value} target="_blank" rel="noreferrer">
                <IconMediaFolder fillColor="primary-700" />
            </a>
        </div>
    );
}
